import AutoMatchTabContainer from './AutoMatchTabContainer';

export default AutoMatchTabContainer;
